const translation = {
  home: {
    heroTitle1: '韩漫免费看 📚',
    heroTitle2: '下拉式漫画大全',
    heroDesc: '在韩漫屋享受韩漫免费看的乐趣，下拉式漫画大全与友好的韩国漫画在线界面，为您营造温馨舒适的阅读环境。',
    readNow: '立即阅读',
    viewRanking: '查看榜单',
    hotCategory: '🔥 热门分类推荐',
    weeklyPick: '本周强推',
    ctaTitle: '随时随地追更韩漫',
    ctaSubtitle: '支持手机、平板、电脑全平台阅读，下拉式体验，畅快追更',
    ctaButton: '开始阅读之旅',
  },
  category: {
    browseAll: '全部漫画',
    totalWorks: '部作品',
    editorsPick: '编辑精选',
    filterLatest: '最新更新',
    filterPopular: '最受欢迎',
    filterRating: '评分最高',
  },
  comic: {
    backToList: '← 返回列表',
    startReading: '开始阅读',
    chapterList: '章节列表',
    latestUpdate: '最近更新',
    relatedComics: '相关推荐',
    readerReviews: '读者评价',
    subscribeUpdate: '订阅更新提醒',
    subscribeDesc: '新章节第一时间通知您',
  },
  about: {
    pageTitle: '关于韩漫屋 🏠',
    missionTitle: '友好界面',
    missionSubtitle: '温馨阅读',
    missionDesc: '韩漫屋致力于为全球韩漫爱好者打造最友好的在线阅读平台。我们相信每一部漫画都值得被认真对待，每一位读者都值得拥有最舒适的下拉式阅读体验。',
    contactUs: '联系我们',
    brandIntro: '品牌介绍',
    reputation: '口碑与荣誉',
    contactTitle: '联系方式',
    faqTitle: '常见问题',
  },
  nav: {
    home: '首页',
    category: '分类浏览',
    featured: '本周强推',
    about: '关于我们',
  },
  footer: {
    explore: '探索发现',
    categoryList: '漫画分类',
    support: '帮助支持',
    subscribe: '订阅更新',
    subscribePlaceholder: '输入您的邮箱',
    subscribeBtn: '订阅',
    copyright: '韩漫屋',
    allRightsReserved: '保留所有权利',
    rights: '© 2026 韩漫屋. All rights reserved.',
  },
};

export default translation;